// extracted by mini-css-extract-plugin
export default {"crown":"PlayerEndScreen_crown__u6Uu6","noCrown":"PlayerEndScreen_noCrown__xB1EM"};